"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("@/bootstrap");
// Components
var alerts_1 = require("@/components/alerts");
var navigation_1 = require("@/components/navigation");
var scroll_1 = require("@/components/scroll");
var animasection_1 = require("./components/animasection");
// Packages
var ui_1 = require("@fancyapps/ui");
// Initializers
var docReady = function () {
    new alerts_1.AlertSession();
    (0, navigation_1.Navigation)();
    (0, scroll_1.Scroll)();
    animasection_1.default.observeAll();
};
var winLoad = function () {
    // ...
};
var docReadyWinload = function () {
    // ...
};
// ---
// [IMPORTANT] Do not change or add anything!
document.addEventListener("DOMContentLoaded", function () {
    docReady();
    docReadyWinload();
    ui_1.Fancybox.bind("[data-fancybox]", {
    // Your custom options
    });
}, false);
window.addEventListener("load", function () {
    winLoad();
    docReadyWinload();
}, false);
// ---
// ---
